import mapActionToReducer from 'redux-action-reducer-mapper';
import reduceReducers from 'reduce-reducers';
import { mainReducers } from './mainReducers';

export const initialState = {
  isADMAdminScreen: false,
  isLoadingActiveTranslations: true,
  isLoadingTranslationsData: true,
  openModals: [],
  activeTranslations: [],
  availableADMTranslations: [],
  isCustomSearch: false,
  searchFilteredTranslationData: {},
  translationKeyToSearch: '',
  currentActiveLanguage: {},
  isLoadingTranslationsTemplate: false,
  defaultTranslationsTemplate: {},
  currentLocaleTranslations: {},
  currentLocaleCustomTranslations: {},
  translationsData: {},
  stagedEdits: {},
  hasStagedChanges: false,
  stagedSelectedAvailableTranslations: [],
  showInLocalLanguage: false,
  editedNodeIds: [],
};

const rootReducer = mapActionToReducer({
  default: initialState,
  ...mainReducers,
});

export default reduceReducers(rootReducer);
